// extracted by mini-css-extract-plugin
export default {"container":"style__container___3CB1e","arrow":"style__arrow___3j2BH"};